t = require('views/internal/teacup-with-helpers')('header_warning_account_transfer_required')

module.exports = t.renderable ({ targetDate, enterpriseDisplayName }) ->
  t.a '.quiet.sso-notice-dismiss.js-dismiss-account-transfer', { href: "#", style: 'float: right' }, ->
    t.icon 'close'
  t.div '.sso-notice', ->
    t.p ->
      t.format 'will-become-owned', { enterpriseDisplayName, targetDate }
    t.a '.sso-notice-learn-more', { href: 'https://help.trello.com/article/1130-managed-enterprise-accounts', target: 'blank' }, ->
      t.format 'find-out-why'


// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_warning_account_transfer_required.coffee